<template>
  <b-row class="app-stepper">
    <b-overlay v-if="showPrev" class="btn-prev-overlay">
      <button @click.prevent.stop="$emit('prev')" :type="typePrev" :class="cssClassPrev"
              :disabled="disabledPrev || loadingPrev" :aria-label="ariaLabelPrev ? ariaLabelPrev : getSlotText('btnPrev', '')">
        <slot name="btnPrev">Zurück</slot>
      </button>
    </b-overlay>
    <slot name="betweenPrevNextButtons"></slot>
    <b-overlay v-if="showNext" class="btn-next-overlay">
      <button @click.prevent.stop="$emit('next')" :type="typeNext" :class="cssClassNext"
              :disabled="disabledNext || loadingNext" :aria-label="ariaLabelNext ? ariaLabelNext : getSlotText('btnNext', '')">
        <slot name="btnNext">Weiter</slot>
      </button>
    </b-overlay>
  </b-row>
</template>

<script>
import { BOverlay, BRow } from 'bootstrap-vue'

export default {
  name: 'Stepper',
  components: {
    BRow,
    BOverlay
  },
  props: {
    loadingPrev: {
      type: Boolean,
      default: false
    },
    loadingNext: {
      type: Boolean,
      default: false
    },
    disabledPrev: {
      type: Boolean,
      default: false
    },
    disabledNext: {
      type: Boolean,
      default: false
    },
    showPrev: {
      type: Boolean,
      default: true
    },
    showNext: {
      type: Boolean,
      default: true
    },
    cssClassPrev: {
      type: String,
      default: 'text'
    },
    cssClassNext: {
      type: String,
      default: 'filled'
    },
    typeNext: {
      type: String,
      default: 'button'
    },
    typePrev: {
      type: String,
      default: 'button'
    },
    ariaLabelNext: {
      type: String
    },
    ariaLabelPrev: {
      type: String
    }
  }
}
</script>
